import type {
  LC_SecurityGroupByPermission,
  SecurityGroupOption,
} from '../types/securityGroupsByPermission.types';


export function mapSecurityGroupByPermission(
  item: LC_SecurityGroupByPermission,
): SecurityGroupOption {
  return {
    id: item.id,
    name: item.name,
  };
}

export function mapSecurityGroupsByPermission(
  items: LC_SecurityGroupByPermission[],
): SecurityGroupOption[] {
  return items.map(mapSecurityGroupByPermission);
}
